import { render, staticRenderFns } from "./ElectronicDocumentsAdd.vue?vue&type=template&id=5386143c&scoped=true"
import script from "./ElectronicDocumentsAdd.vue?vue&type=script&lang=js"
export * from "./ElectronicDocumentsAdd.vue?vue&type=script&lang=js"
import style0 from "./ElectronicDocumentsAdd.vue?vue&type=style&index=0&id=5386143c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386143c",
  null
  
)

export default component.exports